import { render } from "./PreSignupDialog.vue?vue&type=template&id=9655c13e"
import script from "./PreSignupDialog.vue?vue&type=script&lang=js"
export * from "./PreSignupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__